import $ from "jquery";
import {gsap} from "gsap/all";
import {cloneSvg} from "./SvgBank";

// Small circular pie countdown shown in the corner of the action container.
// Clones the design SVG from the bank and swaps its static pie path for a
// live one that empties clockwise as time runs out.
export class CircleTimer {

  constructor($host) {
    this.$host = $host;
    this.tween = null;

    // The pie is a circle with a border as thick as it is wide, which fills it
    // in completely, and shortening that border eats the pie away. This radius
    // is half the pie of the design file, the border makes up the other half.
    this.pieRadius = 25;
    this.circumference = 2 * Math.PI * this.pieRadius;

    const $svg = cloneSvg("circle-timer");
    $svg.find("path").remove();

    this.pie = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    this.pie.setAttribute("class", "pie");
    this.pie.setAttribute("cx", "69.5");
    this.pie.setAttribute("cy", "69.93");
    this.pie.setAttribute("r", this.pieRadius);
    this.pie.setAttribute("stroke-width", this.pieRadius * 2);
    $svg.find("g").append(this.pie);

    this.$el = $('<div class="circle-timer"></div>').append($svg);

    this.$host.append(this.$el);
    this.setProgress(0);
  }

  // Progress runs 0 (full time left, full pie) to 1 (time up, empty pie).
  setProgress(progress) {
    const remaining = (1 - progress) * this.circumference;
    this.pie.setAttribute("stroke-dasharray", `${remaining} ${this.circumference}`);
  }

  start(durationSec, onComplete = null) {
    this.stop();
    this.setProgress(0);

    const state = {progress: 0};
    this.tween = gsap.to(state, {
      progress: 1,
      duration: durationSec,
      ease: "none",
      onUpdate: () => this.setProgress(state.progress),
      onComplete
    });
  }

  stop() {
    if (this.tween) {
      this.tween.kill();
      this.tween = null;
    }
  }

  destroy() {
    this.stop();
    this.$el.remove();
  }
}
